import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';
import { inject } from '@angular/core';
import { NavigationPathFunctions } from '../utils/navigation.path.functions';
import { AuthCloudService } from '../services/cloud/auth-cloud.service';
import { catchError, map, of, tap } from 'rxjs';

export const loggedGuard: CanActivateFn = () => {
  const userToken = StorageService.getAuthToken;
  const router = inject(Router);
  const authCloudService = inject(AuthCloudService);
  if (!userToken) {
    return authCloudService.checkToken().pipe(
      tap((token) => {
        StorageService.setAuthToken = token;
      }),
      map(() => true),
      catchError(() => {
        router.navigate([NavigationPathFunctions.navigateToSignIn()]);
        return of(false);
      })
    );
  }

  return true;
};
